module.exports = __webpack_public_path__ + "img/caravan-club.2b00be7.png";